<template>
  <CommonPages id="about-us" :class="['about-us-page']" titlePrefix="About Us"
    :metaDescription="domainConfig?.['meta']?.des || 'Learn more about our novel translation platform'">

    <div class="about-us-page__content">
      <div class="about-us-page__title">
        About Us
      </div>
      <div class="about-us-page__description">
        Welcome to {{ domainConfig?.siteName }}, where technology meets creativity to bring you a
        vast collection of AI-generated novels. Our platform is dedicated to pushing the boundaries
        of storytelling by harnessing the power of artificial intelligence. We aim to provide
        readers with fresh, imaginative, and diverse narratives that captivate and inspire.
        <br />
        <br />
        At {{ domainConfig?.siteName }}, we believe in the transformative power of stories. Our AI
        is trained on a wide array of genres and styles, allowing it to craft unique tales that
        appeal to readers of all tastes. Whether you're a fan of science fiction, romance, mystery,
        or fantasy, you'll find something to love here.
        <br />
        <br />
        Join us as we explore new frontiers in storytelling and redefine what it means to create and
        enjoy literature in the digital age.
      </div>
    </div>

  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue'
import { mapGetters } from 'vuex'
import '@/css/about.scss'

export default {
  name: 'AboutUs',
  components: {
    CommonPages
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig'
    ])
  },
  methods: {
    navigateToNovel (novel) {
      // 跳转到小说详情页
      const formattedTitle = novel.title.toLowerCase().replace(/\s+/g, '-');
      this.$router.push(`/${novel.category.toLowerCase()}/${formattedTitle}/${novel.id}`);
    }
  }
}
</script> 